{
    "Accessibility Menu": "Erişilebilirlik Menüsü",
    "Reset settings": "Ayarları Sıfırla",
    "Close": "Kapat",
    "Content Adjustments": "İçerik Ayarları",
    "Adjust Font Size": "Yazı Tipi Boyutunu Ayarla",
    "Highlight Title": "Başlığı Vurgula",
    "Highlight Links": "Bağlantıları Vurgula",
    "Readable Font": "Okunaklı Yazı Tipi",
    "Color Adjustments": "Renk Ayarları",
    "Dark Contrast": "Koyu Kontrast",
    "Light Contrast": "Açık Kontrast",
    "High Contrast": "Yüksek Kontrast",
    "High Saturation": "Yüksek Doygunluk",
    "Low Saturation": "Düşük Doygunluk",
    "Monochrome": "Tek Renkli",
    "Tools": "Araçlar",
    "Reading Guide": "Okuma Rehberi",
    "Stop Animations": "Animasyonları Durdur",
    "Big Cursor": "Büyük İmleç",
    "Increase Font Size": "Yazı Tipi Boyutunu Artır",
    "Decrease Font Size": "Yazı Tipi Boyutunu Azalt",
    "Letter Spacing": "Harf Aralığı",
    "Line Height": "Satır Yüksekliği",
    "Font Weight": "Yazı Tipi Kalınlığı",
    "Dyslexia Font": "Disleksi Yazı Tipi",
    "Language": "Dil",
    "Open Accessibility Menu": "Erişilebilirlik menüsünü aç"
}